import RandomContainer from './RandomContainer';
export default RandomContainer;



// WEBPACK FOOTER //
// ./src/containers/RandomCountriesContainer/index.js